import * as React from "react";
const SvgFiRrDharmachakra = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dharmachakra_svg__a)">
      <path
        fill="#062147"
        d="M22.996 10.997h-.042a10.96 10.96 0 0 0-2.508-6.036l.035-.035a1 1 0 0 0-.002-1.414 1 1 0 0 0-1.414 0l-.034.034a10.96 10.96 0 0 0-6.038-2.502V.998A1 1 0 1 0 10.994 1v.046a10.95 10.95 0 0 0-6.033 2.508l-.038-.038A.999.999 0 1 0 3.51 4.93l.038.038a10.95 10.95 0 0 0-2.5 6.034h-.05a1 1 0 0 0 0 2h.05a10.95 10.95 0 0 0 2.504 6.032l-.038.038a.999.999 0 1 0 1.414 1.414l.038-.038A10.94 10.94 0 0 0 11 22.952v.046a1 1 0 0 0 2 0v-.046a10.95 10.95 0 0 0 6.036-2.505l.034.034a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-.034-.034a10.95 10.95 0 0 0 2.504-6.038h.043a1 1 0 0 0 0-2zm-2.052 0-4.044.002a5 5 0 0 0-.73-1.755l2.857-2.861a8.96 8.96 0 0 1 1.917 4.615zM12 14.999c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m5.611-10.031-2.856 2.861A5 5 0 0 0 13 7.1l-.004-4.045a8.96 8.96 0 0 1 4.616 1.913m-6.616-1.912L11 7.1a5 5 0 0 0-1.755.73l-2.86-2.856a8.96 8.96 0 0 1 4.612-1.918M4.97 6.389 7.83 9.245A5 5 0 0 0 7.101 11l-4.045.002A8.96 8.96 0 0 1 4.97 6.389m-1.912 6.613L7.101 13c.13.637.382 1.231.73 1.755l-2.859 2.859a8.95 8.95 0 0 1-1.915-4.612m3.33 6.026 2.857-2.859c.525.348 1.118.6 1.756.73v4.045a8.97 8.97 0 0 1-4.614-1.916M13 20.943v-4.045a5 5 0 0 0 1.756-.73l2.86 2.858A8.95 8.95 0 0 1 13 20.942zm6.03-3.33-2.86-2.858c.348-.525.6-1.118.73-1.756l4.045-.002a8.96 8.96 0 0 1-1.915 4.616"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dharmachakra_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDharmachakra;
